import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { ICustomSelect } from 'src/app/models/generic';
import { IListContract } from 'src/app/models/verification';
import { ApiContractService } from 'src/app/services/api/api-contract.service';

import { SnackbarType } from '../../models/snackbar-type.enum';
import { SnackbarService } from '../../services/snackbar.service';

interface DialogData {
  title: string;
  contratoID: string;
  confirm: string;
  cancel: string;
}

@Component({
  selector: 'app-estornar-card',
  templateUrl: './estornar-card.component.html',
  styleUrls: ['./estornar-card.component.scss']
})
export class EstornarCardComponent implements OnInit, OnDestroy {
  @Input() reverseTransfer: boolean = false;
  contractSubscription: Subscription[] = [];
  contractsToRefund: IListContract[] = [];
  sub!: string;
  confirm: string = 'Confirmar';
  cancel: string = 'Cancelar';
  title: string = 'Você tem certeza que deseja estornar estes contratos?';
  hasSelectedContracts: boolean = false;
  buttonDelete!: FormGroup<any>;
  reasonOpts: ICustomSelect[] = [];


  form!: FormGroup<any>;

  constructor(
    public _dialogRef: MatDialogRef<EstornarCardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _apiContractService: ApiContractService,
    private snackbarService: SnackbarService
  ) { }

  ngOnInit(): void {
    this.subscribeToContractsService();

    if (!this.reverseTransfer) {
      this.buildForm();
      this.getReversalReasons();
    }
  }

  ngOnDestroy(): void {
    this.contractSubscription.forEach((el) => el.unsubscribe());
  }

  subscribeToContractsService(): void {
    const contractSub = this._apiContractService.getContractsArray().subscribe({
      next: (contracts) => {
        this.contractsToRefund = contracts;
      }
    });
    this.contractSubscription.push(contractSub);
  }

  getReversalReasons(): void {
    const reasonSub = this._apiContractService.getReversalReasons().subscribe({
      next: (result: any) => {

        result.Data.forEach((reason: any) => this.reasonOpts.push({ id: reason.ReversalReasonId, name: reason.Description }))

      }
    });

    this.contractSubscription.push(reasonSub);

  }

  removeReverseContract(contract: IListContract): void {
    this._apiContractService.setContractsArray(contract);
  }

  close(): void {
    this._dialogRef.close();
  }

  refundContracts(): void {

    if (this.form.invalid) {
      this.snackbarService.openSnackBar('Preencha os campos obrigatórios.', SnackbarType.Danger, 5000);
      return;
    }

    const idsToRefund = this.contractsToRefund.map((el) => el.ContractId);

    if (idsToRefund.length === 0)
      this.close();

    let reverseContractsSub: Subscription;

    if (this.reverseTransfer) {
      reverseContractsSub = this._apiContractService
        .reverseTransfer(idsToRefund)
        .subscribe({
          next: (result) => { this.close(); }
        });
    } else {
      reverseContractsSub = this._apiContractService
        .reverseContracts(idsToRefund, this.form.controls['ReversalReason'].value)
        .subscribe({
          next: (result: any) => {
            if (result.success) {
              this.snackbarService.openSnackBar(
                'Contrato(s) estornado(s) com sucesso!',
                SnackbarType.Success,
                3000
              );
            }
            else if (result.errors) {
              const errors = result.errors.join('');
              this.snackbarService.openSnackBar(
                errors,
                SnackbarType.Danger,
                5000
              );
            }

            this.close();

            setTimeout(() => {
              const input = document.querySelector('.search-field-input');
              if (input) {
                const event = new Event('change', { bubbles: true });
                input.dispatchEvent(event);
              }
            }, 0);
          }
        });
    }

    this.contractSubscription.push(reverseContractsSub);
  }

  buildForm(): void {
    this.form = new FormGroup<any>({
      ReversalReason: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }


}
